import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import ArrowRight1 from '@assets/images/arrow_right.svg';
import LogoLetmeup from '@assets/images/Logo_letmeupKorean.svg';
import { getUserPayData } from '@components/common';
import { AdminMenuItems, MENUITEMS, MENUITEMS_V2, UserMenuItems } from '@layout/sidebar/menu';
import useHandleAPICall from '@lib/hooks/useHandleAPICall';
import useHandleError from '@lib/hooks/useHandleError';
import useAppStore from '@store/useAppStore';
import { media } from '@styles/mediaQuery';
import { getAllToken } from '@util/token';
import styled from 'styled-components';

import 'dotenv/config';

export const SideBar2 = ({ isShowSide, setIsShowSide, isMobile }) => {
  const { createRequest } = useHandleAPICall();
  const { catchError } = useHandleError();

  const history = useHistory();
  const [menuList, setMenuList] = useState([]);
  const location = useLocation();
  const { userPhoneNumber, merchantKioskVersion, merchantData } = useAppStore();

  const [showPay, setShowPay] = useState(true);

  const { adminToken, userToken, merchantToken } = getAllToken();

  const UserType = useMemo(() => {
    return {
      admin: !!adminToken && !merchantToken,
      adminMerchant: !!merchantToken && !!adminToken,
      merchantUserV1: !!merchantToken && !userToken && !!userPhoneNumber,
      merchantUserV2: !!merchantToken && !!userToken,
      userV2: !!userToken && !merchantToken,
      merchant: !!merchantToken && !userToken,
    };
  }, [userToken, merchantToken, adminToken, userPhoneNumber]);

  useEffect(() => {
    getCurrentMenuAndSaveMenuList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCurrentMenuAndSaveMenuList = () => {
    const currentMenu = checkUserLevelAndGetMenu();
    setMenuList(currentMenu);
    setIsShowSide(false);
  };

  const checkUserLevelAndGetMenu = () => {
    // const level = localStorage.getItem('level');

    let result = [];
    if (UserType.admin) result = AdminMenuItems;
    else if (UserType.userV2) result = [];
    else if (UserType.merchantUserV2 || UserType.merchantUserV1) result = UserMenuItems;
    else {
      // TODO: 키오스크 버전 체크 후 해당 메뉴 바 적용
      try {
        if (merchantKioskVersion > 1) result = MENUITEMS_V2;
        else result = MENUITEMS;
      } catch (error) {
        result = MENUITEMS;
      }
    }
    return JSON.parse(JSON.stringify(result));
  };

  const onClickExtendTopMenu = (type, menuListIndex, topMenuIndex) => {
    if (type === 'link') return getCurrentMenuAndSaveMenuList();
    const menuListCopy = [...menuList];
    const newArray = menuListCopy.map((item, index) =>
      index === menuListIndex
        ? {
            ...item,
            Items: [{ ...item.Items[0], active: true }],
          }
        : {
            ...item,
            Items: [{ ...item.Items[0], active: false }],
          },
    );

    // menuListCopy[menuListIndex].Items[topMenuIndex].active = !menuList[
    //   menuListIndex
    // ].Items[topMenuIndex].active;
    setMenuList(newArray);
  };

  const onClickSubMenu = (menuListIndex, topMenuIndex, subMenuIndex) => {
    const currentMenu = checkUserLevelAndGetMenu();
    setIsShowSide(false);
    currentMenu[menuListIndex].Items[topMenuIndex].active = true;
    currentMenu[menuListIndex].Items[topMenuIndex].children[subMenuIndex].active = true;
    setMenuList(currentMenu);
  };

  const moveToDashBoard = () => {
    const path = menuList?.[0]?.Items?.[0]?.path;
    if (!path) return;
    setIsShowSide(false);
    getCurrentMenuAndSaveMenuList();
    return history.push(path);
  };

  const getShowPay = async () => {
    try {
      if (!merchantData?.id) return;
      const result = await createRequest(getUserPayData, merchantData.id);
      if (result.credit_store_id === null && result.simple_store_id === null) setShowPay(false);
    } catch (error) {
      catchError(error);
    }
  };

  useEffect(() => {
    const level = localStorage.getItem('level');
    if (level === 'merchant' && !userPhoneNumber) getShowPay();
  }, []);
  return (
    <SideBarContainer
      as="nav"
      aria-label="주요 메뉴"
      className={isShowSide ? 'active' : ''}>
      {isMobile ? (
        <SidebarMobileHeader>
          <button type="button" className="brand" onClick={moveToDashBoard}>
            <img src={LogoLetmeup} alt="렛미업" />
            <span>매장 운영센터</span>
          </button>
          <SidebarCloseButton
            type="button"
            aria-label="메뉴 닫기"
            onClick={() => setIsShowSide(false)}>
            <span />
            <span />
          </SidebarCloseButton>
        </SidebarMobileHeader>
      ) : (
        <SidebarBrand type="button" onClick={moveToDashBoard}>
          <img src={LogoLetmeup} alt="렛미업" />
          <span>매장 운영센터</span>
        </SidebarBrand>
      )}
      <SidebarMenu>
        {menuList.map((topMenus, index) => (
          <TopMenus
            key={`${location.pathname}-${index}`}
            menuKey={`${location.pathname}-${index}`}
            pathname={location.pathname}
            menuItemIndex={index}
            onClickExtendTopMenu={onClickExtendTopMenu}
            topMenus={topMenus.Items}
            onClickSubMenu={onClickSubMenu}
            showPay={showPay}
          />
        ))}
      </SidebarMenu>
    </SideBarContainer>
  );
};

const SideBarContainer = styled.div`
  position: fixed;
  z-index: 400;
  width: 15.5rem;
  height: 100vh;
  padding: 1rem 0.75rem;
  background-color: ${({ theme }) => theme.white};
  border-right: 1px solid ${({ theme }) => theme.neutralGray[200]};
  display: flex;
  flex-direction: column;

  ${media.desktop`
    position: fixed;
    top: 0;
    height: 100vh;
    width: min(17rem, 84vw);
    padding: 0.75rem;

    transform: translateX(-100%);
    transition: transform 0.24s cubic-bezier(0.22, 1, 0.36, 1);
    &.active {
      transform: translateX(0);
    }

    > div:last-child {
      overflow: scroll;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/
      }
    }
  `}
`;

const SidebarBrand = styled.button`
  min-height: 4.25rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;

  img {
    width: 6.75rem;
    height: auto;
  }

  span {
    color: ${({ theme }) => theme.neutralGray[400]};
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 2px;
    border-radius: ${({ theme }) => theme.radius.sm};
  }
`;

const SidebarMenu = styled.div`
  width: 100%;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.neutralGray[300]} transparent;

  &::-webkit-scrollbar {
    width: 0.35rem;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: ${({ theme }) => theme.radius.full};
    background: ${({ theme }) => theme.neutralGray[300]};
  }
`;

const SidebarMobileHeader = styled.div`
  width: 100%;
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.25rem 0 0.75rem;
  border-bottom: 1px solid ${({ theme }) => theme.neutralGray[200]};

  .brand {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;

    img {
      width: 6.25rem;
    }

    span {
      color: ${({ theme }) => theme.neutralGray[400]};
      font-size: 0.68rem;
      font-weight: 700;
    }
  }
`;

const SidebarCloseButton = styled.button`
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  border: 0;
  border-radius: 0.75rem;
  background: ${({ theme }) => theme.main[100]};
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;

  span {
    position: absolute;
    left: 0.65rem;
    top: 1.18rem;
    display: block;
    width: 1.2rem;
    height: 0.125rem;
    border-radius: 999px;
    background: ${({ theme }) => theme.darkNavy};
  }

  span:nth-child(1) {
    transform: rotate(45deg);
  }

  span:nth-child(2) {
    transform: rotate(-45deg);
  }

  &:active {
    transform: scale(0.96);
  }
`;

const TopMenus = ({
  menuKey,
  topMenus,
  menuItemIndex,
  onClickExtendTopMenu,
  onClickSubMenu,
  pathname,
  showPay,
}) => {
  useEffect(() => {}, [pathname]);
  return (
    <TopMenusContiner key={menuKey}>
      {topMenus.map((topMenu, index) => (
        <Fragment key={`${pathname}${index}`}>
          <TopMenuItem
            topMenu={topMenu}
            pathname={pathname}
            menuItemIndex={menuItemIndex}
            topItemIndex={index}
            onClickExtendTopMenu={onClickExtendTopMenu}
          />
          {topMenu.children && (
            <SubMenus
              pathname={pathname}
              menuItemIndex={menuItemIndex}
              topItemIndex={index}
              active={topMenu.active}
              subMuens={topMenu.children}
              onClickSubMenu={onClickSubMenu}
              showPay={showPay}
            />
          )}
        </Fragment>
      ))}
    </TopMenusContiner>
  );
};

const TopMenusContiner = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 0 0.25rem;
  padding: 0;
`;

const TopMenuItemContainer = styled.li`
  list-style: none;

  > a,
  > button {
    width: 100%;
    min-height: 2.875rem;
    padding: 0.7rem 0.8rem;
    display: grid;
    grid-template-columns: ${(props) =>
      props.$userLevel === 'user' ? '1fr auto' : '1.25rem 1fr auto'};
    gap: 0.65rem;
    align-items: center;
    border: 0;
    border-radius: ${({ theme }) => theme.radius.sm};
    background: ${(props) => (props.$active ? props.theme.primary : 'transparent')};
    text-align: left;
    cursor: pointer;
    transition: background-color 0.16s ease, color 0.16s ease;

    > img {
      width: 1rem;
      height: 1rem;
    }

    > img:first-child {
      filter: ${(props) =>
        props.$active
          ? 'brightness(0) saturate(100%) invert(1)'
          : 'brightness(0) saturate(100%)'};
      opacity: ${(props) => (props.$active ? 1 : 0.6)};
    }

    > img:last-child:not(:first-child) {
      filter: ${(props) =>
        props.$active
          ? 'brightness(0) saturate(100%) invert(1)'
          : 'brightness(0) saturate(100%)'};
      opacity: ${(props) => (props.$active ? 1 : 0.52)};
    }

    > span {
      min-width: 0;
      color: ${(props) =>
        props.$active ? props.theme.white : 'rgba(24, 31, 43, 0.77)'};
      /* UI 개편(LETMEUP-951) 때 1rem에서 줄었던 것을 원래 크기로 되돌린다. (LETMEUP-961) */
      font-size: 1rem;
      font-weight: ${(props) => (props.$active ? 700 : 600)};
      line-height: 1.25;
      word-break: keep-all;
    }

    &:hover {
      background: ${(props) =>
        props.$active ? props.theme.primary : props.theme.neutralGray[100]};
    }

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.primary};
      outline-offset: -2px;
    }
  }
`;

const TopMenuItem = ({ topMenu, pathname, menuItemIndex, topItemIndex, onClickExtendTopMenu }) => {
  const { userToken, merchantToken, adminToken } = getAllToken();
  const { userPhoneNumber } = useAppStore();
  const UserType = useMemo(() => {
    return {
      merchantUserV1: !!merchantToken && !userToken && !!userPhoneNumber,
      merchantUserV2: !!merchantToken && !!userToken,
      admin: adminToken && !merchantToken,
    };
  }, [userToken, merchantToken, userPhoneNumber]);
  const WithIcon = !(UserType.merchantUserV1 || UserType.merchantUserV2);

  return (
    <TopMenuItemContainer
      $active={pathname.startsWith(topMenu.path) || topMenu.active}
      onClick={() => onClickExtendTopMenu(topMenu.type, menuItemIndex, topItemIndex)}
      $userLevel={!WithIcon ? 'user' : 'else'}>
      {topMenu.type === 'link' ? (
        <Link to={topMenu.path}>
          {WithIcon && topMenu.icon && (
            <img src={topMenu.icon.enabled} alt="" />
          )}
          <span>{topMenu.title}</span>
          {/* <img src={ArrowRight1} alt="arrow-right" /> */}
        </Link>
      ) : (
        <button type="button" aria-expanded={Boolean(topMenu.active)}>
          {WithIcon && topMenu.icon && (
            <img src={topMenu.icon.enabled} alt="" />
          )}
          <span>{topMenu.title}</span>
          <img src={ArrowRight1} alt="arrow-right" />
        </button>
      )}
    </TopMenuItemContainer>
  );
};

const SubMenus = ({
  subMuens,
  active,
  pathname,
  menuItemIndex,
  topItemIndex,
  onClickSubMenu,
  showPay,
}) => {
  return (
    <SubMenuContainer key={`${pathname}-${menuItemIndex}`} $active={active}>
      {subMuens.map((subMenu, index) =>
        !showPay && subMenu?.path.includes('buy') ? (
          <></>
        ) : (
          <SubMenuItem
            key={`${pathname}-${subMenu.path}`}
            $active={pathname.startsWith(subMenu.path)}
            onClick={() => onClickSubMenu(menuItemIndex, topItemIndex, index)}>
            <Link to={subMenu?.path}>
              <span></span>
              <span>{subMenu.title}</span>
              <span></span>
            </Link>
          </SubMenuItem>
        ),
      )}
    </SubMenuContainer>
  );
};

const SubMenuContainer = styled.ul`
  width: 100%;
  display: ${(props) => (props.$active ? 'flex' : 'none')};
  flex-direction: column;
  gap: 0.125rem;
  margin: 0.25rem 0 0.5rem;
  padding: 0 0 0 1.875rem;
`;

const SubMenuItem = styled.li`
  list-style: none;

  > a {
    min-height: 2.5rem;
    padding: 0.6rem 0.75rem;
    display: flex;
    align-items: center;
    border-radius: ${({ theme }) => theme.radius.sm};
    background: ${(props) => (props.$active ? props.theme.primary : 'transparent')};

    > span {
      color: ${(props) =>
        props.$active ? props.theme.white : 'rgba(22, 31, 46, 0.61)'};
      /* 상위 메뉴와 함께 개편 전 크기로 복원. (LETMEUP-961) */
      font-size: 0.875rem;
      font-weight: ${(props) => (props.$active ? 700 : 500)};
    }

    > span:empty {
      display: none;
    }

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.primary};
      outline-offset: -2px;
    }
  }

  &:hover > a {
    background: ${(props) =>
      props.$active ? props.theme.primary : props.theme.neutralGray[100]};
  }
`;
